// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MPHR","toggleWrap":"styles_toggleWrap__BIqJm","content":"styles_content__2WEFx","selectAreaCode":"styles_selectAreaCode__12gAg"};